import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'

const UNCHANGED = 'unchanged'

export const state = {
  fiscalPeriods: []
}
export const mutations = {
  prepare(state, list) {
    if (list && Array.isArray(list)) {
      state.fiscalPeriods = list
    } else {
      state.fiscalPeriods = []
    }
  },
  clear(state) {
    state.fiscalPeriods = []
  }
}
export const actions = {
  async refresh({ dispatch, commit, state, rootGetters }, options) {
    options = _.merge({ force: false }, options)

    // clear
    commit('clear')

    var result = await post(Endpoints.getUrl('fiscalPeriod.listAll'))
    if (result.success) {
      commit('prepare', result.data.items)

      const currentFiscalPeriodId = rootGetters['appContext/getFiscalPeriod'].id
      const updatedFiscalPeriod = result.data.items.find(x => x.id === currentFiscalPeriodId)

      if (updatedFiscalPeriod)
        commit('appContext/set-fiscal-period', updatedFiscalPeriod, { root: true })

    }
  },

  clear({ commit }) {
    commit('clear')
  }
}
export const getters = {
  all: state => {
    return state.fiscalPeriods
  },
  getById: state => id => {
    return _.head(state.fiscalPeriods.filter(x => x.id === id))
  },
  getByCompanyId: (state, getters, rootState, rootGetters) => companyId => {
    if (!companyId)
      companyId = rootGetters['appContext/getCompany'].id

    return state.fiscalPeriods.filter(x => x.companyId === companyId)
  },
  derties: state => {
    return state.fiscalPeriods.filter(item => item.rowState !== UNCHANGED)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
